// extracted by mini-css-extract-plugin
export var actions = "_4s-0";
export var actionsContainer = "_4s-7";
export var border = "_4s-1";
export var childFullHeight = "_4s-e";
export var collapse = "_4s-2";
export var content = "_4s-9";
export var contentChild = "_4s-d";
export var fullscreen = "_4s-b";
export var hasLeftRadius = "_4s-q";
export var headerContainer = "_4s-3";
export var headerRow = "_4s-5";
export var hidePadding = "_4s-a";
export var navCollapsedGap = "_4s-r";
export var noScrollX = "_4s-s";
export var noScrollY = "_4s-t";
export var noTopPadding = "_4s-o";
export var optOutTopPadding = "_4s-c";
export var outletContent = "_4s-k";
export var outletContentInner = "_4s-l";
export var outletLeadingPanel = "_4s-h";
export var outletLeadingPanelAttention = "_4s-i";
export var outletResizeDivider = "_4s-j";
export var outletSplit = "_4s-f";
export var outletSplitResizing = "_4s-g";
export var pageMain = "_4s-p";
export var pageOuter = "_4s-m";
export var pagePadding = "_4s-8";
export var profile = "_4s-u";
export var profileContainer = "_4s-v";
export var profileImage = "_4s-w";
export var profileMain = "_4s-x";
export var profileSubtitle = "_4s-z";
export var profileTitle = "_4s-y";
export var showLeftPadding = "_4s-n";
export var tabsPortalSlot = "_4s-6";
export var tabsWrapper = "_4s-4";
export var title = "_4s-10";